import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  fill(event) {
    event.preventDefault()
    if (this.hasInputTarget) this.inputTarget.value = event.currentTarget.dataset.badge
  }
}
